
const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-16">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Logo e Descrição */}
          <div className="lg:col-span-2">
            <div className="flex items-center space-x-3 mb-6">
              <div className="w-12 h-12 bg-orange-500 rounded-xl flex items-center justify-center">
                <span className="text-white font-bold text-xl">TBAT</span>
              </div>
              <span className="font-bold text-2xl" style={{ fontFamily: '"Pacifico", serif' }}>
                TAX BUSINESS Academia Tributária
              </span>
            </div>
            <p className="text-gray-300 leading-relaxed mb-6 max-w-md">
              Especialistas em educação tributária presencial, capacitando profissionais 
              há mais de 15 anos com conteúdo atualizado e metodologia comprovada.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://linkedin.com/company/academia-tributaria-pro"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-colors"
              >
                <i className="ri-linkedin-fill text-xl"></i>
              </a>
              <a
                href="https://instagram.com/academiatributariapro"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-pink-600 rounded-lg flex items-center justify-center transition-colors"
              >
                <i className="ri-instagram-line text-xl"></i>
              </a>
              <a
                href="https://youtube.com/@academiatributariapro"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-gray-800 hover:bg-red-600 rounded-lg flex items-center justify-center transition-colors"
              >
                <i className="ri-youtube-fill text-xl"></i>
              </a>
            </div>
          </div>

          {/* Contato */}
          <div>
            <h3 className="text-xl font-semibold mb-6">Contato</h3>
            <div className="space-y-4">
              <div className="flex items-start space-x-3">
                <i className="ri-phone-line text-orange-500 mt-1"></i>
                <div>
                  <p className="text-gray-300">(99) 98102-4030</p>
                  <p className="text-gray-400 text-sm">Seg a Sex, 9h às 18h</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-phone-line text-orange-500 mt-1"></i>
                <div>
                  <p className="text-gray-300">(99) 98102-4030</p>
                  <p className="text-gray-400 text-sm">Seg a Sex, 9h às 18h</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-whatsapp-line text-orange-500 mt-1"></i>
                <div>
                  <p className="text-gray-300">(99) 98102-4030</p>
                  <p className="text-gray-400 text-sm">Atendimento rápido</p>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-mail-line text-orange-500 mt-1"></i>
                <div>
                  <a href="mailto:impetuscontatos@gmail.com" className="text-gray-300 hover:text-orange-500 transition-colors">
                    impetuscontatos@gmail.com
                  </a>
                </div>
              </div>
              <div className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-orange-500 mt-1"></i>
                <div>
                  <p className="text-gray-300">Rua. Urbano Santos, 155, Aracati Office, sala 1304</p>
                  <p className="text-gray-300">Imperatriz/MA - CEP 65900-410</p>
                </div>
              </div>
            </div>
          </div>

          {/* Links Úteis */}
          <div>
            <h3 className="text-xl font-semibold mb-6">Links Úteis</h3>
            <div className="space-y-3">
              <a href="#programa" className="block text-gray-300 hover:text-orange-500 transition-colors">
                Programa do Curso
              </a>
              <a href="#beneficios" className="block text-gray-300 hover:text-orange-500 transition-colors">
                Benefícios
              </a>
              <a href="#inscricao" className="block text-gray-300 hover:text-orange-500 transition-colors">
                Inscrições
              </a>
              <a href="/politica-privacidade" className="block text-gray-300 hover:text-orange-500 transition-colors">
                Política de Privacidade
              </a>
              <a href="/termos-uso" className="block text-gray-300 hover:text-orange-500 transition-colors">
                Termos de Uso
              </a>
              <a href="/certificados" className="block text-gray-300 hover:text-orange-500 transition-colors">
                Validar Certificado
              </a>
            </div>
          </div>
        </div>

        {/* Linha divisória */}
        <div className="border-t border-gray-800 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-gray-400 text-sm mb-4 md:mb-0">
              <p>&copy; 2025 TAX BUSINESS Academia Tributária. Todos os direitos reservados.</p>
              <p className="mt-1">CNPJ: 57.823.552/0001-17 | Razão Social: Impetus Ltda.</p>
            </div>
            <div className="flex items-center space-x-4">
              <span className="text-gray-400 text-sm">Desenvolvido por</span>
              <a
                href="https://readdy.ai/?origin=logo"
                target="_blank"
                rel="noopener noreferrer"
                className="text-orange-500 hover:text-orange-400 transition-colors text-sm font-medium"
              >
                Website Builder
              </a>
              <a
                href="tel:+5599981024030"
                className="border-2 border-blue-800 text-blue-800 hover:bg-blue-800 hover:text-white px-6 py-3 rounded-lg font-semibold transition-colors whitespace-nowrap"
              >
                <i className="ri-phone-line mr-2"></i>
                (99) 98102-4030
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
